import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { FormsModule } from '@angular/forms';
import { NgxCarouselModule } from 'ngx-carousel';

import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { LogUpdateService } from './service/log-update.service';
import { CheckForUpdateService } from './service/check-for-update.service';
import { PromptUpdateService } from './service/prompt-update.service';

import { AppComponent } from './app.component';
import { OfferteMinComponent } from './offerte-min/offerte-min.component';
import { Offerte } from './model/offerte';
import { OfferteServiceService } from './service/offerte-service.service';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { ListaofferteComponent } from './listaofferte/listaofferte.component';
import { HomeComponent } from './home/home.component';
import { ChisiamoComponent } from './chisiamo/chisiamo.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { CertificazioneISOComponent } from './certificazioneISO/certificazioneISO.component';
import { FornitoriComponent } from './fornitori/fornitori.component';
import { OffertaComponent } from './offerta/offerta.component';
import { ComodityComponent } from './comodity/comodity.component';
import { FooterComponent } from './footer/footer.component';
import { MenuComponent } from './menu/menu.component';
import { FormComponent } from './form/form.component';
import { FormContactComponent } from './form-contact/form-contact.component';
import { CosaFacciamoComponent } from './cosa-facciamo/cosa-facciamo.component';
import { OffertaMinFotoComponent } from './offerta-min-foto/offerta-min-foto.component';
import { OffertaMinDescrizioneComponent } from './offerta-min-descrizione/offerta-min-descrizione.component';
import { FaqComponent } from './faqs/faq.component';
import { FeaturesComponent } from './features/features.component';
import { FornitoreServiceService } from './service/fornitore-service.service';
import { LeadserviceService } from './service/leadservice.service';
import { ReactiveFormsModule } from '@angular/forms';
import { FineMercatoTutelatoComponent } from './fine-mercato-tutelato/fine-mercato-tutelato.component';
import { ScrollToModule } from 'ng2-scroll-to-el';
import { CookieLawModule } from 'angular2-cookie-law';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TerminiCondizioniComponent } from './termini-condizioni/termini-condizioni.component';
import { PercheSceglierciComponent } from './perche-sceglierci/perche-sceglierci.component';
import { NostriserviziComponent } from './nostriservizi/nostriservizi.component';
import { NostripartnerComponent } from './nostripartner/nostripartner.component';
import { DiconodinoiComponent } from './diconodinoi/diconodinoi.component';
import { OffertecentralihomeComponent } from './offertecentralihome/offertecentralihome.component';
import { HeaderhomeComponent } from './headerhome/headerhome.component';
import { ChisiamoCosafacciamoComponent } from './chisiamo-cosafacciamo/chisiamo-cosafacciamo.component';
import { AssistenzaclientiComponent } from './assistenzaclienti/assistenzaclienti.component';
import { ComefunzionaComponent } from './comefunziona/comefunziona.component';
import { ConsulenzatelefonicaComponent } from './consulenzatelefonica/consulenzatelefonica.component';
import { AvvisoIeComponent } from './avviso-ie/avviso-ie.component';
import { DatipreventivoService } from './service/datipreventivo.service';
import { PreventivoComponent } from './preventivo/preventivo.component';
import { FeaturesComparatoreComponent } from './featuresComparatore/features.component';
import { ComparatoretaskService } from './service/comparatoretask.service';
import { ComparatoreeleComponent } from './comparatoreele/comparatoreele.component';
import { ComparatoregasComponent } from './comparatoregas/comparatoregas.component';
import { HeaderhomeComparatoreComponent } from './headerhome-comparatore/headerhome-comparatore.component';
import { FormHomeComponent } from './form-home/form-home.component';
import { FormLandingComponent } from './form-landing/form-landing.component';
import { OffertecomparatoreComponent } from './offertecomparatore/offertecomparatore.component';
import { RingraziamentoComponent } from './ringraziamento/ringraziamento.component';
import { UnderheadComponent } from './underhead/underhead.component';
import { MigliorioffertehomeComponent } from './migliorioffertehome/migliorioffertehome.component';
import { PreventivoDatiAnagraficiComponent } from './preventivo-dati-anagrafici/preventivo-dati-anagrafici.component';
import { DatePipe } from '@angular/common';
import { LandingPageCanoneStopComponent } from './landing-page-canone-stop/landing-page-canone-stop.component';
import { LandingPageComparatoreComponent } from './landing-page-comparatore/landing-page-comparatore.component';
import { LandingPageContattamiComponent } from './landing-page-contattami/landing-page-contattami.component';
import { AlertlandingComponent } from './alertlanding/alertlanding.component';
import { FormLandingComparatoreComponent } from './form-landing-comparatore/form-landing-comparatore.component';
import { CanoneRaiComponent } from './canone-rai/Canone-rai.component';


@NgModule({
  declarations: [
    AppComponent,
    OfferteMinComponent,
    ListaofferteComponent,
    HomeComponent,
    ChisiamoComponent,
    PrivacyComponent,
    CertificazioneISOComponent,
    FornitoriComponent,
    OffertaComponent,
    ComodityComponent,
    FooterComponent,
    MenuComponent,
    FormComponent,
    FormContactComponent,
    CosaFacciamoComponent,
    OffertaMinFotoComponent,
    OffertaMinDescrizioneComponent,
    FaqComponent,
    FeaturesComponent,
    FineMercatoTutelatoComponent,
    TerminiCondizioniComponent,
    PercheSceglierciComponent,
    NostriserviziComponent,
    NostripartnerComponent,
    DiconodinoiComponent,
    OffertecentralihomeComponent,
    HeaderhomeComponent,
    ChisiamoCosafacciamoComponent,
    AssistenzaclientiComponent,
    ComefunzionaComponent,
    ConsulenzatelefonicaComponent,
    AvvisoIeComponent,
    PreventivoComponent,
    FeaturesComparatoreComponent,
    ComparatoreeleComponent,
    ComparatoregasComponent,
    HeaderhomeComparatoreComponent,
    FormHomeComponent,
    FormLandingComponent,
    OffertecomparatoreComponent,
    RingraziamentoComponent,
    UnderheadComponent,
    MigliorioffertehomeComponent,
    PreventivoDatiAnagraficiComponent,
    LandingPageCanoneStopComponent,
    LandingPageComparatoreComponent,
    LandingPageContattamiComponent,

    AlertlandingComponent,
    FormLandingComparatoreComponent,
    CanoneRaiComponent

  ],
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('/ngsw-worker.js', {enabled: environment.production}) ,
    // environment.production ? ServiceWorkerModule.register('ngsw-worker.js') : [],
    MDBBootstrapModule.forRoot(),
    AppRoutingModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    NgxCarouselModule,
    ReactiveFormsModule,
    ScrollToModule ,
    CookieLawModule ,
    BrowserAnimationsModule  ,
    ReactiveFormsModule
  ],

  schemas: [NO_ERRORS_SCHEMA],
  providers: [
    LogUpdateService,
    CheckForUpdateService,
    PromptUpdateService,
    OfferteServiceService,
    FornitoreServiceService,
    LeadserviceService,
    DatipreventivoService,
    ComparatoretaskService,
    DatePipe

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts